module.exports = __webpack_public_path__ + "static/media/Contributions.5145a4a1.svg";